var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 309.85 280.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-457.78 -206.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 449.41,
    y: 202.65,
    width: 318.22,
    height: 261.33
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M602,301.81c.7-3.08-.51-6-2.71-6.49S594.74,296.9,594,300s.51,6,2.71,6.49,4.55-1.58,5.26-4.66",
    transform: "translate(-457.78 -206.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M561.4,346.52a6.41,6.41,0,0,0,7.23-4.16,95.1,95.1,0,0,1,8-16.81,43.48,43.48,0,0,1-8.76-5.91A1.53,1.53,0,0,1,569,317a70.79,70.79,0,0,0,11.21.65h0a56.52,56.52,0,0,0-21-9.22,2,2,0,0,1-1.23-3.06,19,19,0,0,1,18.06-8.42,43.5,43.5,0,0,1,19.86-15.54c8.32-3.24,16.9-4.37,24.8-1.84,3.19,1,5.09,1.79,6.66,2.42a43.8,43.8,0,0,0,27.5,1.56,3.17,3.17,0,0,1,3.48,4.73,43.65,43.65,0,0,1-25.61,19.49,2.71,2.71,0,0,0-1.92,3.07,56.37,56.37,0,0,0,14.46,29.44,7.37,7.37,0,0,0,7.46,1.94A193.54,193.54,0,0,0,709.41,315c-7.67-20.43-15-41-21.73-62.22C679.54,227.07,652.4,206,627.2,206h-58c-9.08,0-19.26,7.42-22.62,16.49-12.83,34.64-25.53,69.36-38.59,105.32a192.94,192.94,0,0,0,53.46,18.7",
    transform: "translate(-457.78 -206.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M576,434.4l-.16-.28a9.29,9.29,0,0,0-6.69-4.68A131.17,131.17,0,0,1,490,384.81a2.38,2.38,0,0,1,2.17-3.88,131.28,131.28,0,0,0,14,1.09h0q-2.83-2.64-5.55-5.48c-2.6-2.72-5-5.55-7.33-8.43-11,30.39-22.39,61.93-34.44,95.25-4.11,11.37,3.68,23.65,15,23.65H591.47A130.24,130.24,0,0,0,576,434.4",
    transform: "translate(-457.78 -206.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M766.54,463.44c-11.59-32.27-23.43-62.19-34.94-91.32a192.82,192.82,0,0,1-21.29,20.81q6.54-.19,12.94-1a2.16,2.16,0,0,1,1.5,3.94,193.36,193.36,0,0,1-66.16,28.55,4.65,4.65,0,0,0-3.11,6.72A131,131,0,0,0,713.77,487h37.74c11.3,0,19.1-12.21,15-23.56",
    transform: "translate(-457.78 -206.01)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c6fc88f3d86ab91efdde17f9a6725e7f.svg";
export { ForwardRef as ReactComponent };